module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Importação de Bancas")])]), _vm._v(" "), _c('v-card-text', [_c('div', {
    attrs: {
      "xs6": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://minha.unifebe.edu.br/documentos/modelo-importacao-bancas.csv"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://minha.unifebe.edu.br/images/arquivo-csv.png",
      "width": "50",
      "alt": ""
    }
  }), _vm._v("\n                                    Baixe aqui o modelo.\n                                ")])]), _vm._v(" "), _c('v-form', [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "label": "Curso",
      "prepend-icon": "class",
      "data-vv-as": "Curso",
      "data-vv-name": "course",
      "errors": _vm.vErrors.collect('examCourse'),
      "items": _vm.courses,
      "autocomplete": "",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.getExamTypes($event)
      }
    },
    model: {
      value: (_vm.course),
      callback: function($$v) {
        _vm.course = $$v
      },
      expression: "course"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "label": "Tipo",
      "prepend-icon": "create",
      "data-vv-as": "Tipo",
      "data-vv-name": "examType",
      "errors": _vm.vErrors.collect('examType'),
      "items": _vm.examTypes,
      "required": ""
    },
    model: {
      value: (_vm.examType),
      callback: function($$v) {
        _vm.examType = $$v
      },
      expression: "examType"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.switchAux),
      expression: "switchAux"
    }],
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.switchAux),
      expression: "switchAux"
    }],
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.fileImport
    }
  }, [_vm._v("Verificar")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableValues.length),
      expression: "tableValues.length"
    }]
  }, [_c('v-container', [_c('h6', [_vm._v("Dados do arquivo")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeader,
      "items": _vm.tableValues
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          on: {
            "click": function($event) {
              return _vm.addOpcaoCheck($event, props.item.ckbx)
            }
          }
        })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.student.join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.topic))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.semesters))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.date))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.place))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.chair))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.advisor))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.examiners.join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.substitutes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.notes))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.finalScore))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.situation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.obs_of_situation))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.externalNote))])]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "color": "warning",
      "icon": "warning"
    }
  }, [_vm._v("\n                        Aguardando a importação dos dados.\n                    ")])], 1)], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.switchAux),
      expression: "switchAux"
    }],
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.gerarLoteBancas
    }
  }, [_vm._v("Importar")])], 1), _vm._v(" "), (_vm.msgWarning.length) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "warning"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.msgWarning) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.msgErrors.length) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, _vm._l((_vm.msgErrors), function(e) {
    return _c('v-alert', {
      key: e.id
    }, [_c('ul', [_c('h6', [_vm._v("Item: " + _vm._s(e.registro))]), _vm._v(" "), _vm._l((e.data), function(value, index) {
      return _c('li', {
        key: index
      }, [_vm._v(_vm._s(value))])
    })], 2)])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.idBancas.length) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, _vm._l((_vm.idBancas), function(e) {
    return _c('v-alert', {
      key: e.id
    }, [_c('h6', [_vm._v("Item: " + _vm._s(e.registro))]), _vm._v(" "), _c('p', [_vm._v("Banca Importadas com sucesso.")]), _vm._v(" "), _c('p', [_vm._v("Banca Nº "), _c('b', [_vm._v(_vm._s(e.data.id))])])])
  }), 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-274b2af6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamImport.vue
// module id = 243
// module chunks = 0